__turbopack_context__.v({
  "wrapper": "Li-module__S-GujW__wrapper",
});
